import React from 'react';
import './Chat.css';

const SuggestionBubbles = ({ suggestions, onSuggestionClick }) => {
  return (
    <div className="suggestion-chips">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          className="suggestion-chip"
          onClick={() => onSuggestionClick(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default SuggestionBubbles; 